import { Box } from "@mui/material";
import { LiteRaveCreateProvider } from "./LiteRaveCreateContext";
import { Header } from "./components/Header";
import { Form } from "./components/Form";

export const LiteRaveCreate = () => {
  return (
    <LiteRaveCreateProvider>
      <Box>
        <Header />
        <Form />
      </Box>
    </LiteRaveCreateProvider>
  );
};
